import { apiCweb } from './api-cweb';
import { appLog } from '~src/utils/log';

interface LoadArchiveFolderStructureParams {
  projectId: number;
  skip?: number;
  take?: number;
  sort?: string;
}

export const loadArchiveFolderStructure = async (
  key,
  { projectId, skip, take, sort }: LoadArchiveFolderStructureParams
) => {
  appLog('loadArchiveFolderStructure -> ', { projectId, skip, take, sort });
  const res = await apiCweb.get(
    `/projects/${projectId}/archive_settings/archive_folder_structure`,
    { params: { skip, take, sort } }
  );
  return res.data;
};

interface InitializeArchiveFolderStructureParams {
  projectId: number;
  folderStructure: Array<{
    name: string;
    description: string;
    sub_folder: any[] | null;
  }>;
}

export const initializeArchiveFolderStructure = async ({
  projectId,
  folderStructure,
}: InitializeArchiveFolderStructureParams) => {
  appLog('initializeArchiveFolderStructure -> ', {
    projectId,
    folderStructure,
  });
  const res = await apiCweb.put(
    `/projects/${projectId}/archive_settings/archive_folder_structure`,
    folderStructure,
    { params: { action: 'initialize_directory_of_archive' } }
  );
  return res.data;
};

interface SyncArchiveFolderStructureParams {
  projectId: number;
  updates: Array<{ id: number; name: string; description: string }>;
  creates: Array<{
    name: string;
    description: string;
    parent_id: number | null;
    sub_folder: any[] | null;
  }>;
}

export const syncArchiveFolderStructure = async ({
  projectId,
  updates,
  creates,
}: SyncArchiveFolderStructureParams) => {
  appLog('syncArchiveFolderStructure -> ', { projectId, updates, creates });
  const res = await apiCweb.put(
    `/projects/${projectId}/archive_settings/archive_folder_structure`,
    { updates, creates },
    { params: { action: 'sync_archive_folder_structure' } }
  );
  return res.data;
};
